module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/Fpinterest.47722be8.svg";